import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import {
  DataPlatformActionsDetailsStatusInfo,
  DataPlatformActionsDetailsTableData,
  DataPlatformTableEntry,
} from '@/models/dataPlatform';
import { DataPlatformActionEnum } from '@/models/enums/DataPlatformEnum';
import { dataPlatformService } from '@/services/dataplatform.service';
import moment from 'moment';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DataPlatformActionsDetailsModal',
  props: {
    dataPlatform: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  dataPlatform: DataPlatformTableEntry;
};





const { t } = useI18n();
const data = ref<DataPlatformActionsDetailsTableData[]>([]);

onMounted(async () => {
  await loadData();
});

async function loadData() {
  data.value = await dataPlatformService.getActionsDetails(
    props.dataPlatform.id,
  );
}

function formatTime(date: Date | null): string {
  if (date === null) {
    return '';
  }
  return moment(date).local().format('YYYY-MM-DD, HH:mm:ss');
}

function sortByStatus(
  a: DataPlatformActionsDetailsTableData,
  b: DataPlatformActionsDetailsTableData,
  isAsc: boolean,
) {
  const a_text = getActionStatus(a).text;
  const b_text = getActionStatus(b).text;
  return isAsc ? a_text.localeCompare(b_text) : b_text.localeCompare(a_text);
}

function getActionStatus(
  actionDetail: DataPlatformActionsDetailsTableData,
): DataPlatformActionsDetailsStatusInfo {
  if (actionDetail.executed) {
    if (actionDetail.errorMessage) {
      return {
        text: t('dataplatforms.modal_actions.result_ko').toString(),
        class: 'is-danger',
        errorMessage: actionDetail.errorMessage,
      };
    }
    return {
      text: t('dataplatforms.modal_actions.result_ok').toString(),
      class: 'is-success',
      errorMessage: '-',
    };
  }
  return {
    text: t('dataplatforms.modal_actions.result_pending').toString(),
    class: 'is-warning',
    errorMessage: '',
  };
}

function getActionName(action: DataPlatformActionEnum): string {
  switch (action) {
    case DataPlatformActionEnum.Restart:
      return t('dataplatforms.actions.restart').toString();
    default:
      return t('dataplatforms.modal.unknown').toString();
  }
}

return { __sfc: true,props, emit, t, data, loadData, formatTime, sortByStatus, getActionStatus, getActionName }
}

})